webpackJsonp([48],{

/***/ "6fxk":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}.market-contracts-stats-popup__content{padding:10px 0}.market-contracts-stats-popup__content--long{max-height:70vh;overflow-y:auto}", "", {"version":3,"sources":["/home/vsts/work/1/s/src/components/market/market-contracts-stats-popup/market-contracts-stats-popup.scss"],"names":[],"mappings":"AACA,yBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AACD,iBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AAQD,uCACE,cAAgB,CACjB,AACD,6CACI,gBAAiB,AACjB,eAAiB,CACpB","file":"market-contracts-stats-popup.scss","sourcesContent":["/* stylelint-disable at-rule-no-unknown */\n@-webkit-keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n@keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n\n/**\n * Foundation for Sites\n * Version 6.6.3\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n.market-contracts-stats-popup__content {\n  padding: 10px 0;\n}\n.market-contracts-stats-popup__content--long {\n    max-height: 70vh;\n    overflow-y: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "ETXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_popup_js__ = __webpack_require__("eFE/");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b364405_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_popup_vue__ = __webpack_require__("X0hB");
function injectStyle (ssrContext) {
  __webpack_require__("wuuS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_popup_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b364405_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "X0hB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contracts-stats-popup"},[_c('switch-modal',{staticClass:"modal-switch--contracts-stats",attrs:{"showSwitchButton":false},on:{"modalClose":_vm.close}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Trading Statistics")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{class:_vm.classModifiers},[_c('market-contracts-stats',{attrs:{"isFixed":_vm.isFixed,"stats":_vm.stats}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eFE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_generics_modal_switch_switch_vue__ = __webpack_require__("iOeH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_contracts_stats_market_contracts_stats_vue__ = __webpack_require__("Y/q+");
/* eslint-disable no-restricted-syntax */




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketContractsStats: __WEBPACK_IMPORTED_MODULE_1__components_market_market_contracts_stats_market_contracts_stats_vue__["a" /* default */],
    switchModal: __WEBPACK_IMPORTED_MODULE_0__components_generics_modal_switch_switch_vue__["a" /* default */]
  },
  props: {
    stats: {
      type: Array,
      required: true
    },
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return {
        'market-contracts-stats-popup__content': true,
        'market-contracts-stats-popup__content--long': this.stats.length > 5
      };
    }
  },
  methods: {
    close: function close() {
      this.$emit('modalClose');
    }
  }
});

/***/ }),

/***/ "wuuS":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6fxk");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("60c2b8ba", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/48.2de5211d9b29f7f0ebd0.js